module.exports = __webpack_public_path__ + "img/group.99a22ad5.png";